import { render, staticRenderFns } from "./company.profile.page.vue?vue&type=template&id=7b79d972&scoped=true&"
import script from "./company.profile.page.vue?vue&type=script&lang=js&"
export * from "./company.profile.page.vue?vue&type=script&lang=js&"
import style0 from "./company.profile.page.vue?vue&type=style&index=0&id=7b79d972&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79d972",
  null
  
)

export default component.exports